/**
 * start-data-export-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { SummarizationLabel } from "../../../aggregation/summarization";
import { CollectionType, ServerDataType }
  from "../../../common/data/data-types";
import { SubjectContextType } from "../../../subjects/subject-context-type";
import { AggregationFilterNode } from "../aggregation/start-aggregator-request";
import { Message, ReplyVerifyingMessage } from "../general/";
import { MessageTag } from "../message-tag";

export interface ColumnDescription
{
  name : string; // the state variable name
  columnName : string; // the name for the column in the output
  summarization : SummarizationLabel; // how to flatten collections
}

export class StartDataExportRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_START_DATA_EXPORT;
  public static tag : MessageTag = MessageTag.REQ_START_DATA_EXPORT;

  /**
   * Construct a new {@link StartDataExportRequest}.
   */
  constructor (
    public exportId : number,
    public filterTree : AggregationFilterNode,
    public targetColumns : ColumnDescription[],
    public useHeaders : boolean = true,
    public customInnerDelimiter? : string,
    public useExcelDates : boolean = true,
    public excludeRecordsFailingCollectionFilters : boolean = true
  )
  {
    super();
    if (!filterTree)
    {
      delete this.filterTree;
    }
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_START_DATA_EXPORT);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/start-data-export-request.ts